import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-file-review',
  templateUrl: './loan-file-review.component.html',
  styleUrls: ['./loan-file-review.component.scss']
})
export class LoanFileReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
